import React from 'react';
import { connect } from 'react-redux';
import { Form, Input, InputNumber, message, Modal } from 'antd';
import * as actions from '../redux/actions/agents';

class EditAgent extends React.Component {

    state = {
        confirmLoading: false,
    }
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 12,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 12,
            span: 16,
        },
    };

    onFinish = async (values) => {
        let agent = {
            id: this.props.agentDetail.id,
            name: values.name,
            mobile: values.mobile,
            balance: values.balance,
        }
        await this.props.onUpdate(agent, this.props.token);
        this.setState(prevState => {
            return {
                ...prevState,
                confirmLoading: true,
            }
        });
        setTimeout(() => {
            this.setState(prevState => {
                return {
                    ...prevState,
                    confirmLoading: false,
                }
            });
            this.props.onCloseForm();
        }, 400)
    }
    onFinishFailed = (errorInfo) => {
        message.error('All inputs are required. Input correctly.');
    }
    handleCancel = () => {
        this.props.onCloseForm();
    }
    render() {
        return (
            <Modal
                title="Edit Agent"
                key={this.props.agentDetail.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'edit-agent-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.state.confirmLoading}
                onCancel={this.handleCancel}
                okText="Save"
            >
                <Form
                    style={{ margin: 25 }}
                    id="edit-agent-form"
                    {...this.layout}
                    name="basic"
                    initialValues={{
                        name: this.props.agentDetail.name,
                        mobile: this.props.agentDetail.mobile,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[
                            {
                                required: true,
                                message: 'Require name!',
                            },
                            { min: 3, message: 'Minimum 3 characters.' },
                        ]}
                        hasFeedback
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="mobile"
                        label="Mobile"
                        rules={[
                            {
                                required: true,
                                message: 'Require mobile!',
                            },
                            { min: 9, message: 'Minimum 9 numbers.' },
                        ]}
                        hasFeedback
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        visible: state.agents.editAgentVisible,
        agentDetail: state.agents.agentDetail,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onCloseForm: () => dispatch(actions.closeAgentEdit()),
        onUpdate: (agent, token) => dispatch(actions.updateAgent(agent, token)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditAgent);